import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Close({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'14px'} height={'14px'} viewBox={'0 0 14 14'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-5.000000, -5.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M17.2928932,5.29289322 C17.6834175,4.90236893 18.3165825,4.90236893 18.7071068,5.29289322 C19.0976311,5.68341751 19.0976311,6.31658249 18.7071068,6.70710678 L6.70710678,18.7071068 C6.31658249,19.0976311 5.68341751,19.0976311 5.29289322,18.7071068 C4.90236893,18.3165825 4.90236893,17.6834175 5.29289322,17.2928932 L17.2928932,5.29289322 Z M5.29289322,6.70710678 C4.90236893,6.31658249 4.90236893,5.68341751 5.29289322,5.29289322 C5.68341751,4.90236893 6.31658249,4.90236893 6.70710678,5.29289322 L18.7071068,17.2928932 C19.0976311,17.6834175 19.0976311,18.3165825 18.7071068,18.7071068 C18.3165825,19.0976311 17.6834175,19.0976311 17.2928932,18.7071068 L5.29289322,6.70710678 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Close.propTypes = {
  className: PropTypes.string,
}
